import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const WorkLifeBalanceIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path d="m21.9 17.3.1-.7-.1-.7 1.5-1.1c.1-.1.2-.3.1-.5l-1.4-2.4c-.1-.2-.3-.2-.4-.2l-1.7.8-1.1-.7-.3-1.8c-.1-.2-.2-.3-.4-.3h-2.8c-.2 0-.3.1-.3.3l-.2 1.8-1.2.7-1.7-.7c-.2-.1-.3 0-.4.2l-1.4 2.4c-.1.1-.1.3.1.4l1.5 1.1v1.4l-1.5 1.1c-.1.1-.2.3-.1.4l1.4 2.4c.1.2.3.2.4.2l1.7-.7 1.2.7.2 1.8c0 .2.2.3.3.3h2.8c.2 0 .3-.1.3-.3l.2-1.8 1.2-.7 1.7.7c.2.1.3 0 .4-.2l1.4-2.4c.1-.1.1-.3-.1-.4l-1.4-1.1zm-5.1 1.6c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3c1.3 0 2.3 1 2.3 2.3 0 1.3-1 2.3-2.3 2.3zM14.3 4.3c0-2.1-1.6-3.8-3.7-3.8h-.2a4 4 0 0 0-3 1.4A4.1 4.1 0 0 0 4.3.5 3.7 3.7 0 0 0 .5 4.2v.2c0 2.6 2.3 4.7 5.9 7.9l1 .9 1-.9c3.5-3.3 5.9-5.4 5.9-8z" />
    </IconBase>
  );
};

export default WorkLifeBalanceIcon;
